import { io } from 'socket.io-client';

// const URL = "http://localhost:3003"
const URL = "https://server.wilaya.womi.ma"

export const socket = io(URL);
